'use client'

import { createContext, useState } from "react";

interface LoadingOverlayContextType {
    isLoading: boolean;
    toggleLoading: (loading: boolean) => void;
}

interface LoadingOverlayProviderProps {
    children: React.ReactNode;
}

export const LoadingOverlayContext = createContext<LoadingOverlayContextType>({ 
    isLoading: false, 
    toggleLoading: () => { } 
});

export const LoadingOverlayProvider = ({ children }: LoadingOverlayProviderProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const toggleLoading = (loading: boolean) => {
        setIsLoading(loading);
    }
    
    const value = { isLoading, toggleLoading };

    return (
        <LoadingOverlayContext.Provider value={value}>
            {children}
            {isLoading && (
                <div className="loading-overlay fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center z-50">
                    <div className="loader2"></div>
                    {/* <div className="text-white text-lg ml-4">Loading...</div> */}
                </div>
            )}
        </LoadingOverlayContext.Provider>
    )
}